const sendToAnalytics = (action: string = "", error: any = null) => {
  console.error(action, error);
};

export const CHANGE_AGENDAMENTO = "CHANGE_AGENDAMENTO";

export const changeAgendamento = (agendamento: any) => {
  return async (dispatch: any) => {
    try {
      dispatch({
        type: CHANGE_AGENDAMENTO,
        agendamento: agendamento,
      });
    } catch (error: any) {
      sendToAnalytics(error);
      throw error;
    }
  };
};
